enum ComparisonOption {
	UNDEFINED,
	EXACT,
	ALL,
	ANY,
}

export default ComparisonOption;
